import React from 'react';
import { Wine } from 'lucide-react';

// Elegant neutral placeholder — final photography drops in later by swapping `src`.
export function ImagePlaceholder({ src, alt, className = '', ratio = 'aspect-[4/5]', credit, label, contain = false, position }) {
  return (
    <div className={`placeholder-lux relative overflow-hidden rounded-xl border border-[#D4AF37]/20 ${ratio} ${className}`}>
      {src ? (
        <img src={src} alt={alt} style={position ? { objectPosition: position } : undefined} className={`w-full h-full ${contain ? 'object-contain' : 'object-cover'}`} />
      ) : (
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 text-[#D4AF37]/40">
          <Wine size={40} strokeWidth={1} />
          {label && <span className="font-mono text-[10px] tracking-widest uppercase text-[#D4AF37]/50 px-4 text-center">{label}</span>}
        </div>
      )}
      {credit && (
        <span className="absolute bottom-1 right-2 text-[9px] font-sans text-slate-400/70">{credit}</span>
      )}
    </div>
  );
}
